module.exports = __webpack_public_path__ + "media/images/icon-arrow-right-8e9463db6da412593f7a84aa64cb7723.svg";